module.exports = __webpack_public_path__ + "static/media/certified_regular.45729aa7.png";